(function () {
  'use strict';

  if (window.S10Calendly) return;
  window.S10Calendly = true;

  var EVENT_MAP = {
    'calendly.profile_page_viewed': 'invitee_profile_page',
    'calendly.event_type_viewed': 'invitee_event_type_page',
    'calendly.date_and_time_selected': 'invitee_select_time',
    'calendly.event_scheduled': 'invitee_meeting_scheduled'
  };

  function isCalendlyOrigin(origin) {
    try {
      var hostname = new URL(origin).hostname;
      return hostname === 'calendly.com' || hostname.slice(-13) === '.calendly.com';
    } catch (error) {
      return false;
    }
  }

  function isKnownCalendlyFrame(source) {
    return Array.prototype.some.call(
      document.querySelectorAll('[data-s10-calendly] iframe'),
      function (iframe) {
        return iframe.contentWindow === source;
      }
    );
  }

  function buildUtm(attribution) {
    var paidClickId =
      attribution.gclid ||
      (attribution.wbraid ? 'wbraid:' + attribution.wbraid : '') ||
      (attribution.gbraid ? 'gbraid:' + attribution.gbraid : '');

    return {
      utmSource: attribution.utm_source || '',
      utmMedium: attribution.utm_medium || '',
      utmCampaign: attribution.campaign_id || attribution.utm_campaign || '',
      utmContent: paidClickId || attribution.utm_content || '',
      utmTerm:
        attribution.utm_term ||
        attribution.asset_group_id ||
        attribution.target_id ||
        ''
    };
  }

  function compactObject(object) {
    return Object.keys(object).reduce(function (result, key) {
      if (object[key]) result[key] = object[key];
      return result;
    }, {});
  }

  function initialiseWidgets() {
    if (!window.Calendly || typeof window.Calendly.initInlineWidget !== 'function') return;

    document.querySelectorAll('[data-s10-calendly]').forEach(function (element) {
      if (element.getAttribute('data-s10-calendly-ready') === 'true') return;

      var url = element.getAttribute('data-calendly-url');
      if (!url) return;

      var initialise = function () {
        var attribution = window.S10Attribution ? window.S10Attribution.get() : {};

        window.Calendly.initInlineWidget({
          url: url,
          parentElement: element,
          utm: compactObject(buildUtm(attribution))
        });

        element.setAttribute('data-s10-calendly-ready', 'true');
        element.classList.add('is-ready');
      };

      if (window.S10Attribution && window.S10Attribution.ready) {
        window.S10Attribution.ready.then(initialise);
      } else {
        initialise();
      }
    });
  }

  function loadWidgetScript() {
    var script = document.querySelector('script[data-s10-calendly-widget]');

    if (window.Calendly) {
      initialiseWidgets();
      return;
    }

    if (!script) {
      script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      script.setAttribute('data-s10-calendly-widget', '');
      script.setAttribute('data-cookiecategory', 'functionality');
      document.head.appendChild(script);
    }

    script.addEventListener('load', initialiseWidgets, { once: true });

    if (!window.S10CalendlyWaitTimer) {
      var attempts = 0;
      window.S10CalendlyWaitTimer = window.setInterval(function () {
        attempts += 1;
        if (window.Calendly) {
          window.clearInterval(window.S10CalendlyWaitTimer);
          window.S10CalendlyWaitTimer = null;
          initialiseWidgets();
        } else if (attempts >= 120) {
          window.clearInterval(window.S10CalendlyWaitTimer);
          window.S10CalendlyWaitTimer = null;
        }
      }, 250);
    }
  }

  window.addEventListener('message', function (message) {
    if (!isCalendlyOrigin(message.origin) || !isKnownCalendlyFrame(message.source)) return;
    if (!message.data || !message.data.event) return;

    var mappedEvent = EVENT_MAP[message.data.event];
    if (!mappedEvent) return;

    var payload = message.data.payload || {};
    var uri =
      (payload.invitee && payload.invitee.uri) ||
      (payload.event && payload.event.uri) ||
      '';
    var widget = Array.prototype.find.call(
      document.querySelectorAll('[data-s10-calendly]'),
      function (element) {
        var iframe = element.querySelector('iframe');
        return iframe && iframe.contentWindow === message.source;
      }
    );
    var bookingType = widget ? widget.getAttribute('data-booking-type') : 'showroom';
    if (widget) widget.setAttribute('data-s10-calendly-interacted', 'true');
    var parameters = {
      calendly_event: message.data.event,
      booking_type: bookingType || 'showroom',
      booking_page: window.location.pathname
    };
    var deduplicationKey =
      mappedEvent + ':' + (uri || bookingType + ':' + window.location.pathname);

    if (window.S10Attribution && window.S10Attribution.pushDataLayerOnce) {
      window.S10Attribution.pushDataLayerOnce(
        mappedEvent,
        parameters,
        deduplicationKey
      );
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(
        Object.assign({ event: mappedEvent, event_source: 'calendly_embed' }, parameters)
      );
    }
  });

  document.addEventListener('DOMContentLoaded', loadWidgetScript);
  document.addEventListener('shopify:section:load', loadWidgetScript);
  document.addEventListener('s10:attribution-updated', function () {
    document.querySelectorAll('[data-s10-calendly-ready="true"]').forEach(function (element) {
      if (element.getAttribute('data-s10-calendly-interacted') === 'true') return;

      element.innerHTML = '';
      element.removeAttribute('data-s10-calendly-ready');
      element.classList.remove('is-ready');
    });
    loadWidgetScript();
  });
})();
